export default "__VITE_ASSET__CqV0KmCv__"